/* unplugin-vue-components disabled */import script from "./office-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./office-area.vue?vue&type=script&setup=true&lang=ts"

import "./office-area.vue?vue&type=style&index=0&id=af07527a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af07527a"]])

export default __exports__